import {CustomTag, TagColor, TagType} from "../../domain";
import {BffTagResponse, TagsBffListResponse} from "../domain";

export function tagListBffMapper(response: TagsBffListResponse) {
  return response.filter(
    tag => tag.companiesIds && tag.type === 'custom'
  ).map(tagBffResponseToCustomTagMapper)
}

export function tagBffResponseToCustomTagMapper(response: BffTagResponse) {
  return CustomTag.getInstance({
    tag: {
      id: Number(response.id),
      color: (response.color || '').toUpperCase() as TagColor,
      name: response.name,
      type: response.type as TagType,
    },
    companies: response.companiesIds || []
  })
}
